<template>
    <div id="cards">
      <template v-if="cardList.length">
          <div class="quan" v-for="(item,index) in cardList" :key="index" :class="{used:(item.use_status == 'yes')}">
            <div class="info">
              <div class="img">
                <div class="tip" v-if="item.type == 'discount'">折扣券</div>
                <div class="tip tip1" v-else-if="item.type == 'money'">代金券</div>
                <div class="tip tip2" v-else-if="item.type == 'gift'">礼品券</div>
                <div class="tip tip3" v-else-if="item.type == 'coupon'">优惠券</div>
                <div class="tip tip3" v-else="item.type == 'ticket'">门票券</div>
                <img src="../../../statics/imgs/quan.png" alt="">
              </div>
              <div class="text">
                <h3>{{item.title}}</h3>
                <p>有效期：{{item.end_time.split(' ')[0]}}</p>
              </div>
            </div>
            <div class="state" v-if="item.use_status == 'no'">
              <div class="cut"></div>
              <a class="btn" v-if="item.type == 'ticket'"></a>
              <a class="btn" v-else @click="getCode(item)">兑换</a>
            </div>
            <div class="state over" v-else>
              <div class="cut"></div>
              已使用
            </div>
          </div>
      </template>
        <div v-else class="nothing">
            <img :src="imgPath+'nothing.png'" alt="暂无数据">
        </div>

      <van-popup v-model="isShowQRimg">
          <div class="codebox">
            <p>兑奖二维码</p>
            <img :src="codeImg">
            <p>兑奖码：{{qrCode}}</p>
          </div>
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import tool,{app_Id} from '../../kits/Tools.js';
import vxxData from '../../kits/data.js';
import { Waterfall } from 'vant';
import { Toast } from 'vant';
Vue.use(Toast);
import QRCoder from 'qrcoder';
    //保存数据

    export default {
        directives: {
          WaterfallLower: Waterfall('lower')
        },
        data() {
            return {
              fansId:"",
              cardList:[],
              isShowQRimg:false,
              qrCode:'',
              timer:'',
              item:'',
              imgPath:'',
              codeImg:''
            }
        },
        mounted() {
					var that = this;
					this.imgPath = tool.imgPath();
					tool.login(app_Id,function(user){
						    that.fansId = user.fans_id;
								Toast.loading({mask: true});
								that.getData();
					});
        },
        methods: {
            getData(){
              var that = this;
              var option = 'fans_id='+this.fansId+'&page=1&page_nums=100';
              this.axios.post(tool.baseUrl()+'/coupon/index/lists',option).then(function(data){
                Toast.clear();
                if(data.data.code == "200") {
                  that.cardList = data.data.data.list;
                }else{
                  console.log(data.data.message)
                }
              }).catch(function(){
                console.log(data.data.message)
              })
            },
            getCode(item){
              var that = this;
              var url = tool.baseUrl()+'/fans/index/createLink';
              var option = 'fans_id='+this.fansId+'&type=1&code='+item.code;
              this.item = item;
              this.axios.post(url,option).then(function(res){
                var data = res.data;
                if(data.code == "200"){
                  var link;
                  if(location.href.indexOf('?') != -1){
                    link = location.href.split('?')[0];
                  }else{
                    link = location.href.split('#')[0];
                  }
                  link += '?type='+data.data.type+'&data0='+data.data.data0+'&data1='+data.data.data1+'&data2='+data.data.data2;
                  link += '#/check';
                  var qrcoder = new QRCoder({
                    data: link,
                    size: 225
                  });
                  that.codeImg = qrcoder.getDataURL();
                  that.qrCode = item.code;
                  that.isShowQRimg = true;
                  console.log(link);
                } else {
                  Toast(data.message);
                }
              }).catch(function(data){
                Toast(data.message);
              })
            },
            cance(item){
              var that = this;
              var url = tool.baseUrl()+'/fans/index/createLink';
              var option = 'fans_id='+this.fansId+'&type=1&code='+item.code;
              this.axios.post(url,option).then(function(res){
                var data = res.data;
                if(data.code == "202"){
                  that.isShowQRimg = true;
                  Toast('核销成功');
                  clearInterval(that.timer);
                  setTimeout(function(){
                    location.reload();
                  },2000)
                }
              }).catch(function(data){
                Toast(data.message);
              })
            }
        },
        beforeDestroy () {
          clearInterval(this.timer)
        },
        watch:{
          isShowQRimg(){
            var that = this;
            if(this.isShowQRimg){
              this.timer = setInterval(function(){
                that.cance(that.item);
              },1000)
            }else{
              clearInterval(this.timer);
            }
          }
        }
    }
</script>

<style scoped>
#cards {
  padding: 24px 30px;
  height: 100%;
  background: #f1f0f6;
  box-sizing: border-box;
  overflow: scroll;
}
.codebox{
  text-align: center;
}
h3 {
  font-weight: bold;
  color: #252525;
}

p {
  color: #7f7f7f;
  line-height: 30px;
}

.quan {
  margin-bottom: 24px;
  display: flex;
  background: #fff;
  height: 90px;
}
.quan.used{
  opacity: 0.8;
}
.quan .info {
  padding: 20px 0 20px 10px;
  flex: 1;
  display: flex;
}

.quan .img {
  width: 50px;
  height: 50px;
  position: relative;
  background: #f1f0f6;
  margin-right: 8px;
  overflow-y: hidden;
}
.quan .img img{
  width: 100%;
}

.quan .tip {
  position: absolute;
  left: -18px;
  top: 4px;
  width: 60px;
  height: 14px;
  line-height: 14px;
  font-size: 8px;
  background: #ffc11a;
  text-align: center;
  color: #fff;
  transform: rotate(-45deg);
}

.quan .tip1 {
  background: #ff8e1f;
}

.quan .tip2 {
  background: #fd3f3f;
}

.quan .tip3 {
  background: #3fd2bf;
}

.quan .state {
  width: 70px;
  position: relative;
  padding-right: 8px;
  background: #fd3f3f;
  text-align: center;
  line-height: 88px;
  color: #fff;
  overflow: hidden;
  font-size: 16px;
}

.quan .btn {
  display: block;
}

.quan .over {
  background: #d0d0d0;
}

.quan .cut,.quan .state:after,.quan .state:before {
  content: '';
  position: absolute;
  right: -16px;
  width: 24px;
  height: 24px;
  background: #f1f0f6;
  border-radius: 50%;
}

.quan .cut {
  top: 5px;
}

.quan .state:after {
  top: 34px;
}

.quan .state:before {
  top: 63px;
}
</style>


// WEBPACK FOOTER //
// cards.vue?0e0b4329